module.exports = __webpack_public_path__ + "img/claw2.80211ee5.png";